module.exports = __webpack_public_path__ + "img/nfbz-table-1@2x.e62bb178.png";